import { createSelector } from 'reselect';

export const getAnnouncementsState = createSelector(
  [(state) => state.news.announcements], 
  news => news,
  {
    devModeChecks: {identityFunctionCheck: 'never'}
  }
);
